import { fetchPut } from 'Services/fetchService.js';
import { ITasksContactsRequest, ITaskscontactsResponse } from 'CommonTypes/Tasks/Contacts/TasksContacts';
import { nodePath } from 'Config/path.js';

export default async ({ taskId, contactsIds }: ITasksContactsRequest) => {
    const response: ITaskscontactsResponse = await fetchPut(`${nodePath}/contacts/tasks/${taskId}`, { contactsIds });

    return response;
};
